export default {
  // Unauthenticated Links
  LOGIN: { label: "Sign In", url: "/sign-in/" },
  OAUTH_SUCCESS: { label: "Authentication Success", url: "/oauth2/success" },
  OAUTH_ERROR: { label: "Authentication Error", url: "/oauth2/error" },

  // General links
  HOME: { label: "Home", url: "/" },
  CONTACT: { label: "Raise Contact Event", url: "/raise-contact-event/" },
  TERMS: { label: "Terms and Conditions", url: "/terms-and-conditions/" },
  PRIVACY: { label: "Privacy", url: "/privacy/" },
  SUPPORT: { label: "Support", url: "/support/" },
  MEDICINE_CONTROL_EMAIL: "medicinescontrol@health.govt.nz",

  AUDIT_HISTORY: { label: "Audit History", url: "/audit-history/" },
  CONTROLLED_DRUGS: {
    label: "Controlled Drugs Report",
    url: "/controlled-drugs-reporting/"
  },
  RESOURCES: { label: "Resources", url: "/resources/" },

  // CAM Links
  CAM_LIST: { label: "Respond to corrective actions", url: "/cam/" },
  CAM_RESPONSE: {
    label: "Submit Corrective Action Response",
    url: "/cam/submit-response/"
  },

  // Detail Links
  MY_DETAILS: { label: "My Details", url: "/my-details/" },
  MY_PREMISES: { label: "My Premises", url: "/my-premises/" },
  MY_PREMISE: { label: "My Premise", url: "/my-premises/" },
  MY_LEGAL_ENTITIES: { label: "My Legal Entities", url: "/my-legal-entities/" },
  MY_LEGAL_ENTITY: { label: "My Legal Entity", url: "/my-legal-entities/" },

  // DHB Links
  AUDIT_STATUS_REPORT: {
    label: "Audit Status Report",
    url: "/audit-status-report/"
  },
  CAM_STATUS_REPORT: {
    label: "Corrective Action Status Report",
    url: "/cam-status-report/"
  },

  // Registers Links
  PHARMACY_LICENSE_REGISTER: {
    label: "Pharmacy License Register",
    url: "https://www.medsafe.govt.nz/index.asp"
  },
  VERIFY_RI: {
    label: "Verify Regulatory Instrument",
    url: "/registers/verify-regulatory-instrument/"
  },
  SEARCH_RESTRICTION_NOTICE: {
    label: "Search Restriction Notice",
    url: "/registers/search-restriction-notice/"
  },

  // Regulatory Instrument Links
  REGULATORY_INSTRUMENTS: {
    label: "Regulatory Instruments",
    url: "/regulatory-instruments"
  },
  APPLY_RI: {
    label: "Apply for new Regulatory Instrument",
    url: "/regulatory-instruments/apply/"
  },
  AMEND_RI: {
    label: "Amend Regulatory Instrument",
    url: "/regulatory-instruments/amend/"
  },
  RENEW_RI: {
    label: "Renew Regulatory Instrument",
    url: "/regulatory-instruments/renew/"
  },
  IMPORT_EXPORT_NOTIFICATION: {
    label: "Import / Export Notification",
    url: "/import-export-notification/"
  },
  IMPORT_EXPORT_LIST: {
    label: "Import / Export Notification",
    url: "/import-export-list/"
  }
};
